import React from 'react';

// TODO: Remove stop icon once https://product-fabric.atlassian.net/browse/DSP-20528 is finalised
export const StopIcon = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect width="16" height="16" rx="2" fill="#172B4D" />
	</svg>
);
